export default __webpack_public_path__ + "static/media/D4.3f97f297.mp3";